/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown>, build: NonNullable<unknown> }} Profile_Version_NativeInputs */

const en_us2_profile_version_native = /** @type {(inputs: Profile_Version_NativeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`App ${i?.version} (build ${i?.build})`)
};

const pt_br2_profile_version_native = /** @type {(inputs: Profile_Version_NativeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`App ${i?.version} (compilação ${i?.build})`)
};

const es_419_profile_version_native = /** @type {(inputs: Profile_Version_NativeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`App ${i?.version} (compilación ${i?.build})`)
};

const pt_pt2_profile_version_native = /** @type {(inputs: Profile_Version_NativeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`App ${i?.version} (compilação ${i?.build})`)
};

const fr_fr2_profile_version_native = /** @type {(inputs: Profile_Version_NativeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`App ${i?.version} (build ${i?.build})`)
};

const de_de2_profile_version_native = /** @type {(inputs: Profile_Version_NativeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`App ${i?.version} (Build ${i?.build})`)
};

const it_it2_profile_version_native = /** @type {(inputs: Profile_Version_NativeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`App ${i?.version} (build ${i?.build})`)
};

/**
* | output |
* | --- |
* | "App {version} (build {build})" |
*
* @param {Profile_Version_NativeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_version_native = /** @type {((inputs: Profile_Version_NativeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Version_NativeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_version_native(inputs)
	if (locale === "es-419") return es_419_profile_version_native(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_version_native(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_version_native(inputs)
	if (locale === "de-DE") return de_de2_profile_version_native(inputs)
	if (locale === "it-IT") return it_it2_profile_version_native(inputs)
	return en_us2_profile_version_native(inputs)
});
export { profile_version_native as "profile.version_native" }